package com.evoapps.evoshift.data.dto.workplace

import kotlinx.serialization.Serializable

@Serializable
data class WorkplaceFinancialsDto(
    val fixedRevenueMonthly: Double = 0.0,
    val commissionPercent: Double = 0.0,
    val includeFixedRevenueInDailyFinancialReport: Boolean = false,
    val salesTargets: Map<String, Double> = emptyMap(),
    /**
     * SH-54: the labour share the staffing hints aim for, in percent; absent = the market's default.
     * SH-95: a share of income when [labourTargetBase] is "INCOME"; without it (saved before
     * SH-95) a share of net sales, converted on reading.
     */
    val labourTargetPercent: Double? = null,
    /** SH-95: "INCOME" once the target is saved as a share of income; absent before. */
    val labourTargetBase: String? = null,
    /** SH-120: net sales per labour hour aimed for; absent = the workplace's own recent figure. */
    val salesPerLabourHourGoal: Double? = null
) {
    companion object {
        const val LABOUR_TARGET_BASE_INCOME = "INCOME"
    }
}
